import {DataSourceType} from './data-source-type.model';
import {ApplicationStatus} from './application-status.model';
import {ApplicationType} from './application-type.model';
import {IntegrationState} from './integration-state.model';
import {APPLICATION_BADGE, FEATURE_TYPES} from './application-properties.model';
import {PII_LEVEL} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/pii-shield.model';

export class Application {
    public guid: string;
    public name: string;
    public activated: boolean;
    public description: string;
    public vendorName: string;
    public url: string;
    public grade: string;
    public region: string;
    public country: string;
    public language: string;
    public dataSourceType: DataSourceType;
    public dataSourceRef: string;
    public icon: string;
    public ownerId: string;
    public status: ApplicationStatus;
    public state: IntegrationState;
    public type: ApplicationType;
    public syncMode: string;
    public modes: string[];
    public expirationTs: Date;
    public configurationStep = 0;
    public privacyPolicyUrl: string;
    public shouldAutoApprove: boolean;
    public defaultApplicationGuid: string;
    public specificTermsOfTrial: string;
    public featureType?: string;
    public passportSsoService?: string;
    public passportSsoClientId?: string;
    public clientGid?: string;
    public categories?: string[];
    public badges?: APPLICATION_BADGE[];
    public isPIIFree: boolean;
    public piiLevel: PII_LEVEL;
    public isDeleting: boolean;

    static isSupportDataIntegration(app: Application): boolean {
        return (<FEATURE_TYPES[]>[FEATURE_TYPES.DataIntegration, FEATURE_TYPES.DataIntegrationAndSSO]).includes(<FEATURE_TYPES>app?.featureType);
    }

    static isSupportSSO(app: Application): boolean {
        return ((<FEATURE_TYPES[]>[FEATURE_TYPES.SSO, FEATURE_TYPES.DataIntegrationAndSSO]).indexOf(<FEATURE_TYPES>app?.featureType) > -1);
    }

    static isAppHasBadge(app: Application, checkedBadge: APPLICATION_BADGE): boolean {
        return app?.badges && app.badges.some((badge: APPLICATION_BADGE) =>
            checkedBadge === badge
        );
    }

    constructor(guid?: string, name?: string, expirationTs?: Date, activated?: boolean, description?: string, url?: string, grade?: string,
        region?: string, country?: string, language?: string, dataSourceType?: DataSourceType,
        dataSourceRef?: string, icon?: string, ownerId?: string, status?: ApplicationStatus, state?: IntegrationState,
        type?: ApplicationType, syncMode?: string, modes?: string[], configurationStep: number = 0) {
        this.guid = guid;
        this.name = name;
        this.activated = activated;
        this.description = description;
        this.url = url;
        this.grade = grade;
        this.region = region;
        this.country = country;
        this.language = language;
        this.dataSourceType = dataSourceType;
        this.dataSourceRef = dataSourceRef;
        this.icon = icon;
        this.ownerId = ownerId;
        this.status = status;
        this.state = state;
        this.type = type;
        this.syncMode = syncMode;
        this.modes = modes;
        this.expirationTs = expirationTs;
        this.configurationStep = configurationStep;
    }
}

export const APP_LAST_STEP = 100;

export const AMPLIFY_MCLASS = 'Amplify mCLASS';
export const AMPLIFY_ALLOWED_VENDOR_APPS = [
    'Amplify',
    AMPLIFY_MCLASS
];
export const POSSIP_APP_GUID = '82a533d8-04f1-4bcf-98db-c3b3a1ee3a98';
